<template>
  <v-menu
    v-model="menu"
    right
    :open-on-hover="hover"
    :close-on-content-click="false"
    max-width="500px"
    nudge-right="400px"
    nudge-top="200px"
  >
    <template v-slot:activator="{ on, attrs }">
      <div @click="hover = false" :class="{ 'rounded-pill mb-1': true, 'grey lighten-2': menu }">
        <div class="d-flex flex-row py-2" v-bind="attrs" v-on="on">
          <div
            class="ml-2"
            :style="`width:18px;height:18px;
                              border-radius:13px;background-color:${activityColor(activity)}`"
          ></div>

          <div class="ml-2 mr-3" style="border-radius: 8px; width: 100%">
            <div class="ml-3">
              {{ activity.sortingDate | zonedDate("p", activity.display_timezone) }} -
              <b>{{ activity.name }}</b>
            </div>
          </div>
          <div class="d-flex flex-row" v-if="activity.privacy === 3">
            <v-icon
              class="ml-1"
              v-for="key in Object.keys(activity.subgroups || {}).sort()"
              :key="key"
              small
              :color="subgroupColor(key)"
            >
              mdi-account-group
            </v-icon>
          </div>
        </div>
      </div>
    </template>
    <v-card class="pa-0 ma-0">
      <v-img :src="getImage(activity)" aspect-ratio="1.8"></v-img>
      <div class="d-flex flex-row align-center pr-2">
        <v-card-title class="text-h5 font-weight-black flex-grow-1 pb-0">{{
          activity.name
        }}</v-card-title>

        <v-btn @click="handleEdit(activity)" class="mr-2" icon
          ><v-icon color="secondary">mdi-pencil</v-icon>
        </v-btn>
        <!-- <v-btn icon @click="handleDelete(activity)"
          ><v-icon color="secondary">mdi-delete</v-icon></v-btn
        >
        <v-btn icon @click="handleDelete(activity)"
          ><v-icon color="secondary">mdi-content-copy</v-icon></v-btn
        > -->
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click="hover = false">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item two-line @click="handleClone(activity, false)">
              <v-list-item-icon> <v-icon>mdi-content-copy</v-icon> </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("common.cloneActivity") }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t("common.copyActivity") }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="handleClone(activity, true)">
              <v-list-item-icon> <v-icon>mdi-export</v-icon> </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("common.exportActivity") }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t("common.exportActivityTrip") }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop="handleDelete(activity)">
              <v-list-item-icon> <v-icon>mdi-delete</v-icon> </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("common.deleteActivity") }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t("common.deleteTrip") }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-card-text class="pt-0">
        <div></div>
        <div class="primary--text font-weight-bold d-flex flex-row justify-space-between">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                {{ activity.sortingDate | zonedDate("p", activity.display_timezone) }} &nbsp;
                <span class="grey--text text-decoration-underline">{{ timezoneStr }}</span>
              </div>
            </template>
            <span>{{ timezoneTooltip }}</span>
          </v-tooltip>

          <div>{{ activity.sortingDate | zonedDate("PP", activity.display_timezone) }}</div>
        </div>
        <quill-editor
          v-if="activity.description || activity.quill_description"
          class="editor"
          ref="myQuillEditor"
          :options="editorOption"
          @ready="editorReady"
          :disabled="true"
        />
        <div class="d-flex flex-column mt-2" v-if="activity.privacy === 3">
          <div
            class="d-flex flex-row align-center"
            v-for="key in Object.keys(activity.subgroups || {}).sort()"
            :key="key"
          >
            <v-icon class="ml-1" :key="key" :color="subgroupColor(key)"> mdi-account-group </v-icon>
            <div class="ml-2 font-weight-bold">Sub-group: {{ subgroupName(key) }}</div>
          </div>
        </div>
        <div class="d-flex flex-row">
          <div v-if="activity.attendance">
            <v-btn
              outlined
              small
              class="mr-2 text-none"
              color="primary"
              dark
              @click="showCheckins()"
            >
              Check-Ins
            </v-btn>

            <CheckinsDialog
              ref="checkinsDialog"
              :name="activity.name"
              :attendees="activity.attendees"
            />
          </div>
          <div v-if="activity.feedback">
            <v-btn outlined small class="text-none" color="primary" dark @click="showFeedback()">
              Feedback
            </v-btn>
            <FeedbackDialog
              ref="feedbackDialog"
              :name="activity.name"
              :ratings="activity.ratings"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
  <!-- </v-tooltip> -->
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";
import CheckinsDialog from "../Dialogs/CheckinsDialog.vue";
import FeedbackDialog from "../Dialogs/FeedbackDialog.vue";

export default {
  props: ["activity", "value", "subgroups"],
  components: {
    quillEditor,
    CheckinsDialog,
    FeedbackDialog,
  },
  data() {
    return {
      hover: true,
      menu: null,
      descriptionDialog: false,
      readMoreActivated: false,
      editorOption: {
        modules: {
          toolbar: null,
        },
        placeholder: "",
        readOnly: true,
        theme: "snow",
      },
      colors: {
        event: "#F7A400",
        virtual: "#8D72E8",
        hotel: "#FF6B48",
        travels: "#5297E7",
        flights: "#5297E7",
      },
      groupColors: [
        "#b3050e",
        "#ed1d28",
        "#f1bcbe",
        "#f99c22",
        "#e3c415",
        "#82b76a",
        "#3c9a41",
        "#3c8b9a",
        "#42ace0",
        "#5b8cda",
        "#2820a2",
        "#a085d4",
        "#c853b3",
      ],
    };
  },
  computed: {
    imageUrls() {
      return this.$store.state.imageUrls;
    },
    timezoneTooltip() {
      const { activity } = this.$props;
      if (activity.location && activity.location.time_zone) {
        return `${moment.tz.zone(activity.location.time_zone).name.split("/").pop()}\n time`;
      }
      // if (activity.origin && activity.origin.time_zone) {
      //   return `${moment.tz.zone(activity.origin.time_zone).name.split("/").pop()}\n time`;
      // }
      if (activity.remote_tz) {
        return `${moment.tz.zone(moment.tz.guess()).name.split("/").pop()} time`;
      }
      return "";
    },
    timezoneStr() {
      const { activity } = this.$props;
      if (activity.location && activity.location.time_zone) {
        const offset = moment.tz
          .zone(activity.location.time_zone)
          .utcOffset(activity.location.date.seconds * 1000);
        return `GMT${offset > 0 ? "-" : "+"}${Math.abs(offset / 60)}`;
        // .abbr(activity.location.date.seconds * 1000);
      }

      if (activity.remote_tz) {
        return moment.tz.zone(moment.tz.guess()).abbr(activity.location.date.seconds * 1000);
      }
      return "";
    },
  },
  methods: {
    showCheckins() {
      this.hover = false;
      this.$refs.checkinsDialog.dialog = true;
    },
    showFeedback() {
      this.hover = false;
      this.$refs.feedbackDialog.dialog = true;
    },
    userShortName(id) {
      return this.$store.getters.userShortName(id);
    },
    getImageUrlById(id) {
      return this.$store.getters.getImageUrlById(id);
    },
    handleEdit(activity) {
      this.$emit("edit", activity);
    },
    handleClone(activity, forExport) {
      this.$emit("clone", { activity, forExport });
    },
    handleDelete(activity) {
      this.$emit("delete", activity);
    },
    tooltipUpdated(activityId) {
      this.$emit("input", activityId);
    },
    subgroupName(subgroupId) {
      return (
        this.$props.subgroups.find((s) => s.id === subgroupId) || {
          name: "",
        }
      ).title;
    },
    subgroupColor(subgroupId) {
      return (
        this.$props.subgroups.find((s) => s.id === subgroupId) || {
          color: this.groupColors[this.groupColors.length - 1],
        }
      ).color;
    },
    getImage(item) {
      const url = this.imageUrls[item.id];
      if (url) {
        return url;
      }
      const { files } = item;

      if (files && files.header) {
        const cityImages = {};
        Object.values(this.$store.state.trip.cities).forEach((city) => {
          const imageUrl = city.image;
          let imageName;
          if (!imageUrl) return;

          if (imageUrl.includes("wikimedia")) {
            imageName = `${city.wiki_code}.${imageUrl.split(/[#?]/)[0].split(".").pop().trim()}`;
          } else {
            imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
          }
          cityImages[imageName] = imageUrl;
        });
        if (cityImages[files.header] != null) {
          return cityImages[files.header];
        }
      }

      try {
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/img/${
          files && files.header && !files.header.includes("/")
            ? `${files.header.toLowerCase()}.jpg`
            : "other.jpg"
        }`);
      } catch (e) {
        return require("@/assets/img/other.jpg");
      }
    },
    activityColor(activity) {
      if (activity.collection === "travels" || activity.collection === "flights") {
        return this.colors[activity.collection];
      }
      if (activity.remote_tz) {
        return this.colors.virtual;
      }
      if (activity.hotel) {
        return this.colors.hotel;
      }
      return this.colors.event;
    },
    editorReady(quill) {
      if (this.$props.activity.quill_description) {
        const quillDescription = JSON.parse(this.$props.activity.quill_description).ops;
        quill.setContents(quillDescription);
      } else {
        quill.setText(this.$props.activity.description);
      }
    },
  },
  watch: {
    menu(newVal) {
      if (!newVal) {
        this.hover = true;
      }
    },
    activity() {
      if (!this.$refs.myQuillEditor) return;
      const { quill } = this.$refs.myQuillEditor;
      if (quill) {
        this.editorReady(quill);
      }
    },
  },
};
</script>

<style >
.ql-snow {
  border: none !important;
}
</style>
